




import { defineComponent, onMounted } from '@vue/composition-api';

import { client, onLogout } from '@/vue-apollo';
import { useRouter } from '@ideavivat/vivat-2';

const Logout = defineComponent({
  setup() {
    const { router } = useRouter();

    onMounted(async () => {
      localStorage.removeItem('VIVAT_PERMISSION');
      await onLogout(client);
      router.push({ name: 'Login' });
    });
  },
});

export default Logout;
